import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {TextInputComponent} from "../../../../components/text-input/text-input.component";
import {AuthService} from "../../../../services/auth/auth.service";
import {FormBuilder, Validators} from "@angular/forms";
import {passwordValidationErrorMessage, passwordValidator} from "../../../../validators";
import {DynamicDialogRef} from "primeng/dynamicdialog";
import {FormInputsComponent} from "../../../../components/form-inputs/form-inputs.component";
import {CustomFormComponent} from "../../../../components/custom-form/custom-form.component";
import {MessageService} from "primeng/api";

@Component({
  selector: 'homey-change-password-modal',
  imports: [
    TextInputComponent,
    FormInputsComponent,
    CustomFormComponent
  ],
  templateUrl: './change-password-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangePasswordModalComponent {
  private readonly fb = inject(FormBuilder);
  private readonly authService = inject(AuthService);
  private readonly dialogRef = inject(DynamicDialogRef);
  private readonly messageService = inject(MessageService);

  protected readonly form = this.fb.group({
    oldPassword: this.fb.nonNullable.control('', [Validators.required]),
    newPassword: this.fb.nonNullable.control('', [Validators.required, passwordValidator]),
  });

  protected readonly submit = async () => {
    await this.authService.changePassword({
      oldPassword: this.form.getRawValue().oldPassword,
      newPassword: this.form.getRawValue().newPassword
    });

    this.messageService.add({severity: 'success', summary: 'Success', detail: 'Password changed successfully'});
    this.dialogRef.close();
  }
  protected readonly passwordValidationErrorMessage = passwordValidationErrorMessage;
}
